import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CmLocalizationService } from '../services';

/** @deprecated */
@Injectable()
export class CmLocalizationGuard implements CanActivate {
	localizationsInitialized: boolean = false;
	constructor(private readonly localizationService: CmLocalizationService) {}

	canActivate(): Observable<boolean> {
		if (!this.localizationsInitialized) {
			this.localizationsInitialized = true;
			return this.localizationService.init();
		} else {
			return of(true);
		}
	}
}
